import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { categoryName } from "@/lib/media";

interface MediaCardProps {
  item: MediaItem;
  index?: number;
}

export default function MediaCard({ item, index = 0 }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer rf-fade-up"
      style={{ animationDelay: `${Math.min(index, 11) * 45}ms` }}
      title={`${item.title} - 红狐影视`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title}海报 - 红狐影视影视资源推荐`}
          title={`${item.title} + 红狐影视`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 right-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-1 backdrop-blur-sm">
          <i className="ri-star-fill text-accent-400 text-xs"></i>
          <span className="text-xs font-semibold text-background-50">
            {item.rating.toFixed(1)}
          </span>
        </div>
        <span className="absolute bottom-2 left-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {categoryName(item.category)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
          {item.originalTitle}
        </p>
        <div className="mt-2 flex items-center gap-2 text-xs text-foreground-600">
          <span>{item.year}</span>
          <span className="text-background-300">·</span>
          <span>{item.region}</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded-md bg-secondary-100/80 px-1.5 py-0.5 text-[11px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}